import { render, staticRenderFns } from "./room-card.vue?vue&type=template&id=6d85628d&"
import script from "./room-card.vue?vue&type=script&lang=ts&"
export * from "./room-card.vue?vue&type=script&lang=ts&"
import style0 from "./room-card.vue?vue&type=style&index=0&id=6d85628d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports